<!--财务中心 客户结算(供应商) 开票明细 -->
<template>
  <div>
    <el-row>
      <el-form :inline="true" class="demo-form-inline" :model="statusForm" :ref="statusForm" style="margin: 0">
        <el-button size="medium" type="primary" plain @click="exportList" style="margin-top: 20px">导出</el-button>
      </el-form>
    </el-row>
    <el-row>
      <el-col>
        <el-table border stripe :data="tableData" show-summary style="margin-top: 20px">
          <el-table-column type="index" label="序号" width="50"></el-table-column>
          <el-table-column label="产品编码" prop="PRODUCT_CODE"></el-table-column>
          <el-table-column label="品牌" prop="BRAND" min-width="100"></el-table-column>
          <el-table-column label="品名" prop="SHORT_NAME" min-width="100"></el-table-column>
          <el-table-column label="规格" prop="SPECIFICATION" min-width="100"></el-table-column>
          <el-table-column label="单位" prop="TYPE_UNIT"></el-table-column>
          <el-table-column label="均价" prop="AVERAGE_PRICE"></el-table-column>
          <el-table-column label="实收数量 " prop="REAL_COUNT"></el-table-column>
          <el-table-column label="实收总金额" prop="PRODUCT_FEE"></el-table-column>
        </el-table>
      </el-col>
      <el-col :span="24" style="text-align: right">
        <el-pagination @current-change="doQueryTable3(currentPage3 - 1)" :current-page.sync="currentPage3"
          :page-size="pageSize" layout="total,prev, pager, next, jumper" :total="totalCount">
        </el-pagination>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import http from '@/assets/common/http';
import util from '@/assets/common/util';

export default {
  data() {
    return {
      supplierCustomerInvoiceDetailsParams: JSON.parse(sessionStorage.getItem('supplierCustomerInvoiceDetailsParams')),
      tableData: [],
      currentPage3: 1,
      totalCount: 0,
      pageSize: Number(localStorage.getItem('SMP_PAGE_COUNT')) || 10,
      enterpriseNature: [],
      statusForm: {
        NATURE_CODE_LIST: [],
      },
      isGys: Number(this.$route.params.isgys),
    };
  },
  computed: {
    supplierClientId() {
      return this.supplierCustomerInvoiceDetailsParams.GYS_ID;
    },
    month() {
      return this.supplierCustomerInvoiceDetailsParams.MONTH;
    },
  },
  methods: {
    doQueryTable3(PAGE_INDEX) {
      if (!PAGE_INDEX) {
        this.currentPage3 = 1;
      }
      const params = {
        SERVICE_ID: '10026',
        OTYPE: 33,
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
        GYS_ID: this.supplierClientId,
        MONTH: this.month,
        PAGE_SIZE: this.pageSize,
        PAGE_INDEX,
      };
      http.post(params).then((res) => {
        if (res[0]) {
          this.tableData = res[0].DATA_LIST;
          this.totalCount = res[0].TOTAL_COUNT;
        } else {
          this.tableData = [];
          this.$message.show({ text: '暂无数据', type: 'warning' });
        }
      }).catch((err) => {
        this.$message.show({ text: err, type: 'error' });
      });
    },
    // queryList() {
    //   const params = {
    //     SERVICE_ID: '10026',
    //     OTYPE: 33,
    //     SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    //     GYS_ID: this.supplierClientId,
    //     MONTH: this.month,
    //   };
    //   http.post(params).then((result) => {
    //     if (result.length !== 0) {
    //       this.tableData = result[0].DATA_LIST;
    //     } else {
    //       this.tableData = [];
    //       this.$message.show({ text: '暂无数据', type: 'success' });
    //     }
    //   }).catch((error) => {
    //     this.$message.show({ tetx: error, type: 'error' });
    //   });
    // },
    filtrate() {
      // this.queryList();
      this.doQueryTable3();
    },
    exportList() {
      if (document.body.style.cursor === 'wait') {
      } else {
        document.body.style.cursor = 'wait';
        try {
          const params = {
            SERVICE_ID: '10026',
            OTYPE: 31,
            SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
            GYS_ID: this.supplierClientId,
            MONTH: this.month,
          };
          http.post(params).then((res) => {
            try {
              window.location.href = util.getURLLocalHost(res[0].FILE_PATH);
            } catch (err) {
              this.$message.show({ text: err, type: 'warning' });
            } finally {
              document.body.style.cursor = 'default';
            }
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
            document.body.style.cursor = 'default';
          });
        } finally {}
      }
    },
  },
  created() {
    // this.queryList();
    this.doQueryTable3();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/financeCenter/supplierCustomerInvoiceDetails.vue